import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { EntityTypeEnum, WorkflowActions } from 'api'
import { useModal } from 'view/shared/modal'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { CollateralBasketDialog } from './CollateralBasketDialog'
import { canManageCollateralBasketsSelector } from 'selectors/permissionSelectors'
import { EntityTypeIdRecord } from 'store/notification/notificationTypes'
import { Locale, Translation } from 'locale'

export const AdminCollateralBasketToolbar: React.FC = () => {
  const dispatch = useDispatch()
  const { showModal } = useModal()
  const canManageCollateralBasket = useSelector(canManageCollateralBasketsSelector)

  const onAddButtonClick = useCallback(() => {
    const correlatedResponseCallback = (workflowId: string, newlyAddedEntityIdAndTypes: EntityTypeIdRecord) => {
      showModal(<CollateralBasketDialog workflowId={workflowId} entityId={newlyAddedEntityIdAndTypes[EntityTypeEnum.COLLATERAL_BASKET]} />)
    }
    dispatch(WorkflowActions.createNewWorkflow(EntityTypeEnum.COLLATERAL_BASKET, correlatedResponseCallback))
  }, [dispatch, showModal])

  if (!canManageCollateralBasket) {
    return null
  }

  return (
    <TextButton
      dataTestId={'AdminCollateralBasketToolbar-TextButton-NewCollateralBasket'}
      type={TextButtonType.Primary}
      onClick={onAddButtonClick}>
      {Locale.translate(Translation.TC_ADD_NEW_COLLATERAL_BASKET)}
    </TextButton>
  )
}
